import { FC } from "react";

import { Message } from "@/components/Chatbot/types/chatbotTypes";
import MessageList from "@/components/Chatbot/components/messages/MessageList";

interface MessageContentProps {
  messages: Message[];
  styles: {
    messagesContent: string;
  };
  threadId?: null | number | string;
  onDismiss: (messageId: number) => void;
  onRetry: (messageId: number) => Promise<void>;
  onTypingComplete: (messageId: number) => void;
  onTypingProgress: () => void;
}

export const MessageContent: FC<MessageContentProps> = ({
  messages,
  onDismiss,
  onRetry,
  onTypingComplete,
  onTypingProgress,
  styles,
  threadId,
}) => {
  return (
    <div className={styles.messagesContent}>
      <MessageList
        isOpen={true}
        messages={messages}
        onDismiss={onDismiss}
        onRetry={onRetry}
        onTypingComplete={onTypingComplete}
        onTypingProgress={onTypingProgress}
        threadId={threadId?.toString()}
      />
    </div>
  );
};
